import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../state'

/**
 * Component for the create employee form used in the space full view modals.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.input.select.single.Component,
    ds.input.select.singleEc.Component,
    ds.input.text.Component,
    ds.layout.widget.Component,
    ds.notice.Component,
    ds.overlay.centered.Component,
  ],
  selector: 'atn-space-modal-create-employee-form',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * The target of the selection, used to determine which field the duplicate
   * employee selection should populate.
   */
  public readonly selectionTarget = ngCore.input<ec.models.Target>()

  /** @see {@link state.space.full.jobTitles.Collection} */
  public readonly jobTitlesEc = ngCore.inject(
    state.space.full.jobTitles.Collection,
  )

  /** @see {@link state.space.organizations.Feature} */
  public readonly organizationsFeature = ngCore.inject(
    state.space.organizations.Feature,
  )

  /** @see {@link state.space.full.employee.Collection} */
  public readonly employeesEc = ngCore.inject(
    state.space.full.employee.Collection,
  )

  /** @see {@link state.space.full.employee.plugins.duplicateDetection.Plugin} */
  public readonly employeeDuplicateDetectionPlugin = this.employeesEc.plugins
    .lookup(state.space.full.employee.plugins.duplicateDetection.Plugin)
    .get()

  /** @see {@link ents.core.display.Style} */
  public readonly DisplayStyle = ents.core.display.Style

  /** Whether the Save button should be enabled */
  public readonly isSaveEnabledSg = ngCore.computed(
    (
      employee = this.employeesEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntity()
        .asSignal(),
      isCheckingDuplicates = this.employeeDuplicateDetectionPlugin.feature.selectors.isChecking.asSignal(),
    ) =>
      TypeChecker.isNotNullish(employee) &&
      TypeChecker.isNotFalsish(employee.name?.trim()) &&
      TypeChecker.isNotNullish(employee.organization) &&
      !isCheckingDuplicates,
  )

  /**
   * Updates the staged employee creation with the provided input
   */
  public updateEmployeeHandler = (
    input: Partial<ents.extra.space.Employee.Input>,
  ): void => {
    this.employeesEc.plugins.editingPlugin.feature.actions.edit
      .from('CreateEmployeeForm.Field.Changed')
      .dispatch({ edit: { input } })
  }

  /**
   * Handles the selection of a duplicate employees
   */
  public selectDuplicatesClickHandler(): void {
    this.employeeDuplicateDetectionPlugin.feature.actions.selectDuplicates
      .from('CreateEmployeeForm.SelectDuplicates.Clicked')
      .dispatch({ target: this.selectionTarget() })
  }

  /**
   * Submits the staged employee creation
   */
  public saveClickHandler = (): void => {
    this.employeesEc.plugins.editingPlugin.feature.actions.submit
      .from('CreateEmployeeForm.SaveButton.Clicked')
      .dispatch({ create: true })
  }

  /**
   * Discards the staged employee creation
   */
  public cancelClickHandler = (): void => {
    this.employeesEc.plugins.editingPlugin.feature.actions.discard
      .from('CreateEmployeeForm.CancelButton.Clicked')
      .dispatch({ create: true })
  }
}
